module.exports = __webpack_public_path__ + "img/Header-title-4-SVG.0c905a2d.svg";